import { Link } from "react-router-dom";
import "./RegPulseLinkExpire.css";

const RegPulseLinkExpire = () => {
  return (
    <section className="regpulse-expire-page">
      <div className="regpulse-expire-content">
        <div className="regpulse-expire-icon">!</div>

        <p className="regpulse-expire-eyebrow">EvoNext RegPulse</p>

        <h1>This link has expired.</h1>

        <p className="regpulse-expire-message">
          Verification links are valid for 24 hours. Please sign up again to receive a new one.
          OR
          You have already confirmed your subscription.
        </p>

        <Link to="/home" className="regpulse-expire-back">
          &lt; Back to www.evonext.ai
        </Link>
      </div>
    </section>
  );
};

export default RegPulseLinkExpire;